import { settings } from "../../customize/settings";
import { IBaseError } from "../../interfaces/errors";
import { IMagazzino } from "../../interfaces/place/models";
import { IListResponse } from "../../interfaces/rest";
import { getJWT } from "../../lib/jwt";

const BASE_URL = `${settings.apiUrl}magazzino`

export const getMagazzino = async (id: number): Promise<IMagazzino> => {
	const url = `${BASE_URL}/${id}`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IMagazzino | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IMagazzino;
}

export const getMagazzinoList = async (): Promise<IListResponse<IMagazzino>> => {
	const url = `${BASE_URL}/list`;
	const headers = new Headers();
	headers.append('Content-Type', 'application/json');
	const jwt = getJWT();
	if (jwt) headers.append('Authorization', 'Bearer ' + jwt);
	const response = await fetch(url, {
		method: "GET",
		headers: headers
	});
	const json: IListResponse<IMagazzino> | IBaseError = await response.json();
	if (response.status !== 200) throw json;
	return json as IListResponse<IMagazzino>
}